import { useContext } from "react";
import { UserContext } from "../../App";
import { useParams } from "react-router-dom";
import useAxios from "axios-hooks";
import { UserResDto } from "../../api/Api";
import Members from "../members/Members";

export default function InstructorStudents() {
  const params = useParams();

  const [{ data, loading, error }, getMember] = useAxios<UserResDto>({
    url: `/users/${params.instructorId}`,
  });

  if (loading) {
    return <div></div>;
  }

  return (
    <div>
      <Members
        classroomIds={data?.classrooms.map((classroom: any) => classroom._id)}
      ></Members>
    </div>
  );
}
